module.exports = __webpack_public_path__ + "static/media/adaptive-icon.e4e80208.png";